export enum SeverityType {
  Success,
  Error,
  Info,
  Warning
}

export enum MessageType {
  SystemAlert,
  Alert,
  Toast
}

export interface Message {
  source: string;
  type: MessageType;
  severity: SeverityType;
  title: string;
  image: string;
  message: string;
  timeout: number;
  closeable: boolean;
  closeAfterRouteChange: boolean;
  imageClass: (message: Message) => string;
  severityClass: (message: Message) => string;
}

export class Message implements Message {
  static imageClass(message: Message): string {
    if (message) {
      switch (message.severity) {
        case SeverityType.Success:
          return 'fa fa-3x fa-check';
        case SeverityType.Info:
          return 'fa fa-3x fa-info-circle';
        case SeverityType.Warning:
          return 'fa fa-3x fa-exclamation-circle';
        case SeverityType.Error:
          return 'fa fa-3x fa-exclamation-triangle';
      }
    }
  }

  static severityClass(message: Message): string {
    if (message) {
      let severityClass: string;
      switch (message.type) {
        case MessageType.SystemAlert:
          severityClass = 'system-alert alert alert-';
          break;
        case MessageType.Alert:
          severityClass = 'alert alert-';
          break;
        default:
          severityClass = 'toast toast-';
          break;
      }
      switch (message.severity) {
        case SeverityType.Success:
          return severityClass + 'success';
        case SeverityType.Info:
          return severityClass + 'info';
        case SeverityType.Warning:
          return severityClass + 'warning';
        case SeverityType.Error:
          return severityClass + 'danger';
        default:
          return severityClass + 'default';
      }
    }
  }
}
